mutation updateMarketingPlanSlotSchedule($input: UpdateMarketingPlanSlotScheduleInput!) {
  slot: updateMarketingPlanSlotSchedule(input: $input) {
    id
    platform
    scheduledLocal {
      date
      time
    }
    textStatus
  }
}
